import { render, staticRenderFns } from "./RemoveLiquidity.vue?vue&type=template&id=7a585a08&scoped=true&"
import script from "./RemoveLiquidity.vue?vue&type=script&lang=js&"
export * from "./RemoveLiquidity.vue?vue&type=script&lang=js&"
import style0 from "./RemoveLiquidity.vue?vue&type=style&index=0&id=7a585a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a585a08",
  null
  
)

export default component.exports